import script from "./PettyCashForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PettyCashForm.vue?vue&type=script&setup=true&lang=js"

import "./PettyCashForm.vue?vue&type=style&index=0&id=656b2dce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-656b2dce"]])

export default __exports__